import React, { useRef, useMemo } from 'react';
import styled from 'styled-components';
import { motion, useScroll } from 'framer-motion';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const Container = styled.div`
  height: 100vh;
  height: 100dvh;
  width: 100%;
  max-width: 100vw;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;

  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
`;

const ProgressBar = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: var(--color-portfolio-wine);
  transform-origin: 0%;
  z-index: 1000;
  box-shadow: 0 0 10px rgba(117, 22, 40, 0.6);
`;

export const ScrollContext = React.createContext({ containerRef: null });

const ScrollContainer = ({ children }) => {
  const containerRef = useRef(null);
  const { scrollYProgress } = useScroll({
    container: containerRef
  });

  const contextValue = useMemo(() => ({ containerRef }), []);

  return (
    <ScrollContext.Provider value={contextValue}>
      <ProgressBar style={{ scaleX: scrollYProgress }} />
      <Container ref={containerRef}>
        {children}
      </Container>
    </ScrollContext.Provider>
  );
};

export default ScrollContainer;